<div
    class="file-upload"
    *ngIf="multiple || !files.length"
    appDnd
    (dragenter)="onDragEnter()"
    (dragleave)="onDragEnd()"
    (dragend)="onDragEnd()"
    [ngClass]="isHovered ? 'hovered' : ''"
    data-testid="cy-file-upload"
    (fileDropped)="onFileDropped($event)">
    <input
        class="file-upload__input"
        type="file"
        #fileDropRef
        id="fileDropRef"
        data-testid="cy-file-upload-container"
        [multiple]="multiple"
        (drop)="onFileDropped($event)"
        (change)="fileBrowseHandler($event)" />

    <mat-icon class="riege-icon md-32">file_upload</mat-icon>

    <div class="file-upload__info-text">
        <span i18n="@@dragndrop-text">Drag and drop file here</span><br />
        <span i18n="@@dragndrop-text-or">or</span>
    </div>

    <label class="file-upload__label" for="fileDropRef" i18n="@@label-select-file">Select a file</label>
</div>

<div class="files-list" *ngIf="files.length">
    <div class="files-list__button-container" *ngIf="multiple || !directUpload">
        <button class="button--upload" mat-flat-button color="primary" (click)="uploadFiles()">
            <mat-icon class="riege-icon md-24">file_upload</mat-icon>
            <span i18n="@@button-label-upload-file">Upload files</span>
        </button>
    </div>

    <div class="files-list__item" *ngFor="let file of files; let i = index">
        <div class="files-list__icon">
            <mat-icon class="riege-icon md-32">upload_file</mat-icon>
        </div>
        <div class="files-list__info">
            <div class="name">{{ file?.name }}</div>
            <div class="size">{{ formatBytes(file?.size, 2) }}</div>
            <riege-progress [progress]="progress"></riege-progress>
        </div>

        <button
            mat-icon-button
            class="riege-button riege-button--icon"
            color="warn"
            i18n-aria-label="@@button-label-remove-file"
            aria-label="Remove file"
            i18n-matTooltip="@@button-label-remove-file"
            matTooltip="Remove file"
            matTooltipPosition="above"
            (click)="deleteFile(i)">
            <mat-icon class="riege-icon">delete</mat-icon>
        </button>
    </div>
</div>

<mat-hint ngClass="file-upload__helper-text" *ngIf="validType() && validSize()">
    @if (allowedTypes.length) {
    <span>{{ allowedTypes.length > 1 ? typeFew : typeOne }}</span> {{ allowedTypes.join(', ').toUpperCase() }}. } @if
    (allowedSize > 0) { <span i18n="@@hint-file-supported-size">Maximum file size is</span> {{ formatBytes(allowedSize)
    }} }
</mat-hint>

<mat-error ngClass="file-upload__error" *ngIf="!validSize()">
    <span i18n="@@error-file-supported-size">File size is too big. Allowed file size is</span>
    {{ formatBytes(allowedSize) }}
</mat-error>

<mat-error ngClass="file-upload__error" *ngIf="!validType()">
    <span i18n="@@error-file-supported-type">File type not supported.</span>
    <span>{{ allowedTypes.length > 1 ? typeFew : typeOne }}</span> {{ allowedTypes.join(', ').toUpperCase() }}
</mat-error>
